(function () {
  'use strict';

  if (window.__eleganceArabicFuzzySearchLoaded) return;
  window.__eleganceArabicFuzzySearchLoaded = true;

  if (!/^ar(?:-|$)/i.test(document.documentElement.lang || '')) return;

  var catalogPromise;
  var catalog = [];
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'SAR';
  var money = new Intl.NumberFormat('ar-SA', {
    style: 'currency',
    currency: currency,
    maximumFractionDigits: 2
  });

  function normalizeArabic(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFKD')
      .replace(/[\u064B-\u065F\u0670\u06D6-\u06ED]/g, '')
      .replace(/\u0640/g, '')
      .replace(/[إأآٱ]/g, 'ا')
      .replace(/[ىئ]/g, 'ي')
      .replace(/ؤ/g, 'و')
      .replace(/ة/g, 'ه')
      .replace(/[^\p{L}\p{N}\s]/gu, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function editDistance(a, b) {
    var previous = new Array(b.length + 1);
    var current = new Array(b.length + 1);
    var i;
    var j;

    for (j = 0; j <= b.length; j += 1) previous[j] = j;

    for (i = 1; i <= a.length; i += 1) {
      current[0] = i;
      for (j = 1; j <= b.length; j += 1) {
        current[j] = Math.min(
          current[j - 1] + 1,
          previous[j] + 1,
          previous[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1)
        );
        if (
          i > 1 &&
          j > 1 &&
          a[i - 1] === b[j - 2] &&
          a[i - 2] === b[j - 1]
        ) {
          current[j] = Math.min(current[j], previous[j - 2] + 1);
        }
      }
      var swap = previous;
      previous = current;
      current = swap;
    }

    return previous[b.length];
  }

  function tokenSimilarity(queryToken, candidateToken) {
    if (queryToken === candidateToken) return 1;
    if (candidateToken.indexOf(queryToken) === 0 || queryToken.indexOf(candidateToken) === 0) return 0.93;
    if (candidateToken.indexOf(queryToken) > -1 || queryToken.indexOf(candidateToken) > -1) return 0.84;

    var longest = Math.max(queryToken.length, candidateToken.length);
    if (!longest) return 0;
    return 1 - editDistance(queryToken, candidateToken) / longest;
  }

  function productScore(product, query) {
    var title = normalizeArabic(product.title);
    var searchable = normalizeArabic([
      product.title,
      product.vendor,
      product.type,
      (product.tags || []).join(' ')
    ].join(' '));

    if (title === query) return 220;
    if (title.indexOf(query) === 0) return 190;
    if (title.indexOf(query) > -1) return 175;
    if (searchable.indexOf(query) > -1) return 155;

    var queryTokens = query.split(' ').filter(Boolean);
    var candidateTokens = searchable.split(' ').filter(Boolean);
    var total = 0;
    var weakest = 1;

    queryTokens.forEach(function (queryToken) {
      var best = 0;
      candidateTokens.forEach(function (candidateToken) {
        best = Math.max(best, tokenSimilarity(queryToken, candidateToken));
      });
      total += best;
      weakest = Math.min(weakest, best);
    });

    var average = queryTokens.length ? total / queryTokens.length : 0;
    if (weakest < 0.52 || average < 0.62) return 0;

    return Math.round(average * 120);
  }

  function loadCatalog() {
    if (catalogPromise) return catalogPromise;

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var endpoint = root + 'collections/all?view=arabic-search-index';
    var previewThemeId = new URL(window.location.href).searchParams.get('preview_theme_id');

    if (previewThemeId) endpoint += '&preview_theme_id=' + encodeURIComponent(previewThemeId);

    catalogPromise = fetch(endpoint, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json, text/plain, */*' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Catalog request failed');
        return response.text();
      })
      .then(function (body) {
        var data = JSON.parse(body);
        catalog = Array.isArray(data.products) ? data.products : [];
        return catalog;
      })
      .catch(function () {
        catalogPromise = null;
        return [];
      });

    return catalogPromise;
  }

  function createPanel(input) {
    var form = input.closest('form');
    var field = input.closest('.field') || input.parentElement;
    if (!form || !field || form.querySelector('[data-arabic-fuzzy-search]')) return;

    form.style.position = 'relative';

    var panel = document.createElement('div');
    panel.className = 'arabic-fuzzy-search';
    panel.id = input.id + '-arabic-fuzzy-results';
    panel.setAttribute('data-arabic-fuzzy-search', '');
    panel.setAttribute('role', 'listbox');
    panel.hidden = true;
    field.insertAdjacentElement('afterend', panel);

    input.setAttribute('autocomplete', 'off');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', panel.id);
    input.setAttribute('aria-expanded', 'false');

    var timer;
    var results = [];
    var activeIndex = -1;

    function close() {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      activeIndex = -1;
    }

    function open() {
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function showMessage(message, className) {
      panel.innerHTML = '';
      var messageElement = document.createElement('div');
      messageElement.className = className || 'arabic-fuzzy-search__message';
      messageElement.textContent = message;
      panel.appendChild(messageElement);
      open();
    }

    function select(index) {
      var items = panel.querySelectorAll('[role="option"]');
      if (!items.length) return;

      activeIndex = (index + items.length) % items.length;
      items.forEach(function (item, itemIndex) {
        var selected = itemIndex === activeIndex;
        item.classList.toggle('is-active', selected);
        item.setAttribute('aria-selected', selected ? 'true' : 'false');
      });

      input.setAttribute('aria-activedescendant', items[activeIndex].id);
      items[activeIndex].scrollIntoView({ block: 'nearest' });
    }

    function render(query, products) {
      panel.innerHTML = '';
      results = products;
      activeIndex = -1;

      if (!products.length) {
        showMessage('لم نجد منتجًا قريبًا من «' + query + '»');
        return;
      }

      var heading = document.createElement('div');
      heading.className = 'arabic-fuzzy-search__heading';
      heading.textContent = 'منتجات مقترحة';
      panel.appendChild(heading);

      var list = document.createElement('ul');
      list.className = 'arabic-fuzzy-search__list';

      products.forEach(function (product, index) {
        var item = document.createElement('li');
        item.id = panel.id + '-option-' + index;
        item.className = 'arabic-fuzzy-search__item';
        item.setAttribute('role', 'option');
        item.setAttribute('aria-selected', 'false');

        var link = document.createElement('a');
        link.className = 'arabic-fuzzy-search__link';
        link.href = product.url;
        link.tabIndex = -1;

        if (product.image) {
          var image = document.createElement('img');
          image.className = 'arabic-fuzzy-search__image';
          image.src = product.image;
          image.alt = '';
          image.width = 64;
          image.height = 64;
          image.loading = 'lazy';
          link.appendChild(image);
        }

        var copy = document.createElement('span');
        copy.className = 'arabic-fuzzy-search__copy';

        var title = document.createElement('span');
        title.className = 'arabic-fuzzy-search__title';
        title.textContent = product.title;
        copy.appendChild(title);

        if (Number.isFinite(Number(product.price))) {
          var price = document.createElement('span');
          price.className = 'arabic-fuzzy-search__price';
          price.textContent = money.format(Number(product.price) / 100);
          copy.appendChild(price);
        }

        link.appendChild(copy);
        item.appendChild(link);
        list.appendChild(item);
      });

      panel.appendChild(list);

      var hint = document.createElement('div');
      hint.className = 'arabic-fuzzy-search__hint';
      hint.textContent = 'استخدم الأسهم للتنقل وEnter للاختيار';
      panel.appendChild(hint);
      open();
    }

    function search() {
      var rawQuery = input.value.trim();
      var query = normalizeArabic(rawQuery);

      if (query.length < 2) {
        close();
        return;
      }

      showMessage('جارٍ البحث…', 'arabic-fuzzy-search__message arabic-fuzzy-search__message--loading');

      loadCatalog().then(function (products) {
        if (normalizeArabic(input.value.trim()) !== query) return;

        var ranked = products
          .map(function (product) {
            return { product: product, score: productScore(product, query) };
          })
          .filter(function (entry) {
            return entry.score > 0;
          })
          .sort(function (a, b) {
            return b.score - a.score || a.product.title.localeCompare(b.product.title, 'ar');
          })
          .slice(0, 8)
          .map(function (entry) {
            return entry.product;
          });

        render(rawQuery, ranked);
      });
    }

    input.addEventListener('focus', function () {
      loadCatalog();
      if (input.value.trim().length >= 2) search();
    });

    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(search, 140);
    });

    input.addEventListener('keydown', function (event) {
      if (panel.hidden) return;

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        select(activeIndex + 1);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        select(activeIndex - 1);
      } else if (event.key === 'Enter' && activeIndex >= 0 && results[activeIndex]) {
        event.preventDefault();
        window.location.assign(results[activeIndex].url);
      } else if (event.key === 'Escape') {
        event.preventDefault();
        close();
      }
    });

    document.addEventListener('click', function (event) {
      if (!form.contains(event.target)) close();
    });
  }

  function initialize() {
    document.querySelectorAll('form[role="search"] input[name="q"]').forEach(createPanel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', initialize);
})();